import { useMutation } from "react-query";
import {
  recommendUsers,
} from "../../api/Recommend";

export function useRecommendUsers({ queryConfig = {} } = {}) {
  return useMutation(recommendUsers, queryConfig);
}